import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { InterviewSessionPayload } from '@edtech-ui/core/models/ai-interview/ai-interview-session';
import { AiInterviewSessionService } from '@edtech-ui/core/services/ai-interview-session-service/ai-interview-session.service';
import { EnrollCoursesDialogBoxComponent } from '@edtech-ui/student-dashboard-v2/enroll-courses-dialog-box/enroll-courses-dialog-box.component';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-step-instructions',
  standalone: true,
  imports: [CommonModule,HasPermissionDirective],
  templateUrl: './step-instructions.component.html',
  styleUrl: './step-instructions.component.scss'
})
export class StepInstructionsComponent {
  @Output() continue = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  isStarting = false; 
  PermissionForStudents = PermissionForStudents;


  constructor(
	private route: Router, 
	private toast: ToastrService, 
	private aiSessionService: AiInterviewSessionService,
	private dialog:MatDialog,
	private router:Router
   ) {

  }

  criteria = [
    { icon: 'bi-chat-dots', label: 'Communication Clarity', progress: 90, color: 'var(--role-header)' },
    { icon: 'bi-bullseye', label: 'Technical Accuracy', progress: 80, color: 'var(--btn-green)' },
    { icon: 'bi-person-video3', label: 'Confidence & Body Language', progress: 85, color: 'var(--icon-warning)' },
    { icon: 'bi-diagram-3', label: 'Structure of Answers', progress: 75, color: 'var(--role-type)' },
    { icon: 'bi-book', label: 'Domain Knowledge', progress: 88, color: 'var(--purple-dark)' }
  ];
  startInterview() {

    this.isStarting = true;
    const state = this.aiSessionService.value;
    const payload: InterviewSessionPayload = {
      interview_role: state.role_title!,
      company_id: state.company_id!,
      company_name: state.company_name!,
      interview_round: state.interview_round!,
      duration_minutes: state.duration_minutes!,
      interviewer_id: state.interviewer_id!,
      voice: state.voice || 'alloy',
      avatar_language: state.avatar_language || 'en-US',
      job_description: state.job_description || '',
      resume_file: state.resume_file || null,
      microphone_status: state.microphone_status ?? true,
      camera_status: state.camera_status ?? true,
      internet_status: state.internet_status ?? true,
      internet_speed_mbps: state.internet_speed_mbps || 50,
      preferred_language: state.preferred_language || 'en',
    };

    this.aiSessionService.createInterviewSession(payload).pipe(
		finalize(()=>{
			this.isStarting=false;
		})
	).subscribe({
      next: (res) => {
        if (res.Success && res.Data) {
          this.aiSessionService.update({
            session_id: res.Data.session_id,
            ephemeral_token: res.Data.ephemeral_token,
            webrtc_config: res.Data.webrtc_config,
            openai_api_url: res.Data.openai_api_url,
            model: res.Data.model,
            language: res.Data.language,
            supported_languages: res.Data.supported_languages,
            runtime_instructions: res.Data.runtime_instructions,
          });
          this.route.navigate(['/student-dashboard/interview']);
		  return;
        } 

		 if (res.Status === 402 && !res.Success && res.Data) {
				const popupData = {
					title: res.Data?.title,
					message: res.Data?.message
				};

				const dialogRef = this.openAiPlacementLimitDialogBox(popupData);
				this.router.events.subscribe(() => {
					dialogRef.close();
				})
				return;
			}
		
		this.toast.warning(res.Message || 'Failed to create interview session.');
        
      },
      error: (err) => {
        this.toast.error('Error creating session.');
        this.isStarting = false;
      },
    });
  }

	openAiPlacementLimitDialogBox(data:{title:string,message:string}): MatDialogRef<EnrollCoursesDialogBoxComponent> {
		return this.dialog.open(EnrollCoursesDialogBoxComponent,{
			data
		})
	}

}